// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-TerminalView-content {\n  font-family: Monaco, monospace;\n  color: #C4E1A4;\n  font-size: 11px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: flex-end;\n}\n.x-TerminalView-terminalInput input {\n  color: #C4E1A4;\n  background: inherit;\n  outline: none;\n  border: 0;\n  margin-top: 4px;\n  padding: 3px;\n  width: 100%;\n  box-sizing: border-box;\n  padding-left: 0;\n}\n.x-TerminalView-terminalInput input::-webkit-input-placeholder {\n  color: #777777;\n  font-style: italic;\n}\n.x-TerminalView-command {\n  color: #777777;\n}\n.x-TerminalView-autocompleteArea {\n  font-style: italic;\n  display: flex;\n}\n.x-TerminalView-autocompleteArea span {\n  padding-right: 5px;\n}\n", ""]);
// Exports
exports.locals = {
	"content": "x-TerminalView-content",
	"terminalInput": "x-TerminalView-terminalInput",
	"command": "x-TerminalView-command",
	"autocompleteArea": "x-TerminalView-autocompleteArea"
};
module.exports = exports;
